import { render, staticRenderFns } from "./createTiktok.vue?vue&type=template&id=ccedcb74&scoped=true"
import script from "./createTiktok.vue?vue&type=script&lang=js"
export * from "./createTiktok.vue?vue&type=script&lang=js"
import style0 from "./createTiktok.vue?vue&type=style&index=0&id=ccedcb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccedcb74",
  null
  
)

export default component.exports